import RenderInfo from 'components/RenderInfo';
import React, { useState } from 'react';
import { showError, showSuccess } from 'utils';
import CommonModal from 'components/CommonModal';
import styles from './index.module.scss';
import SearchBar from 'components/Autosuggest/Autosuggest';
import { searchUserByName } from 'services';
import { updateSalesChannel } from 'services/api/salesChannel';

const SalesChannelUser = (props) => {
  const { fetchSalesChannelDetailsFn, details: { objectId = '', user: { objectId: userId = '' } = {}} = {}} = props;
  const [changeUserModalOpen, setChangeUserModalOpen] = useState(false);
  const [user, setUser] = useState({}) as any;

  const toggleModal = () => {
    setChangeUserModalOpen(!changeUserModalOpen);
  };

  const onChangeUser = async () => {
    try {
      await updateSalesChannel({
        id: objectId,
        userId: user?.id,
      });
      toggleModal();
      showSuccess('User updated successfully.');
      await fetchSalesChannelDetailsFn();
    } catch (e) {
      showError(e);
    } finally {
    }
  };

  const handleUserSelect = (suggestion: Record<string, any>) => {
    const user: Record<string, any> = {};
    user.id = suggestion.objectId;
    user.name = suggestion.full_name;
    setUser(user);
  };

  return (
    <div className="d-flex align-items-center">
      <RenderInfo heading="User Id" value={userId} />
      <i onClick={toggleModal} style={{ cursor: 'pointer' }} className="fa fa-pencil" />
      {changeUserModalOpen && (
        <CommonModal
          title="Please select new user"
          cancellable={true}
          toggleModal={toggleModal}
          primaryButtonText="Save"
          primaryButtonOnClick={onChangeUser}
          secondaryButtonText="Cancel"
          secondaryButtonOnClick={toggleModal}
        >
          <div style={{ width: '100%' }} className={`col-md-6 mb-4 col-lg-6`}>
            <div className={styles['label']}>User</div>
            <div className={styles['autosuggest-input']}>
              <SearchBar
                isUser={true}
                className={'form-control'}
                value={user.name || ''}
                setValue={(value) => setUser({ ...user, name: value })}
                searchAPI={searchUserByName}
                searchAPIParamKey={'searchTerm'}
                onSuggestionClicked={handleUserSelect}
              />
            </div>
          </div>
        </CommonModal>
      )}
    </div>
  );
};

export default SalesChannelUser;
